module.exports = __webpack_public_path__ + "static/media/managingtime_sl_active.4eb9e3b7.png";